export class SalaryViewKey {
  static readonly SALARY_OVERVIEW = 'salary/view/salary-overview';
}
